import React from "react";
import { Helmet } from "react-helmet";
import HomeHero from "../components/home/HomeHero";
import OurProducts from "../components/home/OurProducts";
import OurServices from "../components/home/OurServices";
import OurWork from "../components/home/OurWork";
import WhyNEXUS from "../components/home/WhyNEXUS";

export default function Home() {
  return (
    <>
      <Helmet>
        <link rel="conanical" href="https://www.nexuseventsug.com" />
      </Helmet>
      <HomeHero />
      <WhyNEXUS />
      <OurWork />
      <OurServices />
      <OurProducts />
    </>
  );
}
